export class SingIn {
  name: string;
  password: string;
  rememberMe: number;
  constructor(name, password, rememberMe) {
    this.name = name;
    this.password = password;
    this.rememberMe = rememberMe;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/app/class/sing-in.ts